import Pin from './Pin';
export default Pin;
//# sourceMappingURL=index.js.map
